import { Loader } from "@albelli/arc-3-react/lib/Loader/Loader";
import { requestAuth } from "application/auth/authActions";
import { useHistory, useLocation } from "components/_hooks/useRouter";
import { isFinished } from "helpers/requestStateHelper";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isLoading } from "./../../../helpers/requestStateHelper";

export const AuthBoundary = ({ children }) => {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const config = useSelector(state => state.config);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    if (!isFinished(config)) throw new Error("Config should be loaded before authentication");

    dispatch(requestAuth());
  }, []);

  // syncing React Router location with window.location after authentication library redirects
  useEffect(() => {
    const windowRoute = window.location.pathname + window.location.search;
    const reactRoute = location.pathname + location.search;

    if (reactRoute !== windowRoute) {
      history.replace(windowRoute);
    }
  });

  if (isLoading(auth)) {
    return <Loader />;
  }
  return <>{children}</>;
};
